export const DEFAULT_4_3_WIDTH = 25.4;
export const DEFAULT_4_3_HEIGHT = 19.05;
export const DEFAULT_16_9_WIDTH = 33.87;
export const DEFAULT_16_9_HEIGHT = 19.05;
